// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__wNRwl","content":"styles_content__3gJNz"};